import { FetchResult, FetchResultType } from '@/entities/FetchResult'
import { NotificationCenterHeaderName, NotificationCenterLog } from '@/entities/NotificationCenter/NotificationCenter'
import { UserFormData } from '@/entities/User/User'
import { authorizedFetch } from '@/helpers/authorizedFetch'
import { trans } from '@/helpers/trans'
import { generateApiUrl } from '@/helpers/url'
import { isResourceDocument } from '@/japi/guards/isResourceDocument'
import { JapiDocument } from '@/japi/types/Document'

import { Person, PersonResource } from './Person'
import { transformFormDataToEditPersonRequest, transformToPerson } from './PersonTransformers'

export const patchPersonApiCall = async (
    formData: UserFormData,
    personId: string,
    eventLogTrackerData: NotificationCenterLog,
): Promise<FetchResult<Person, string>> => {
    const apiData = transformFormDataToEditPersonRequest(formData, personId)

    try {
        const url = generateApiUrl({ endpoint: `/people/${personId}` })

        const response = await authorizedFetch(url, {
            method: 'PATCH',
            body: JSON.stringify({ data: apiData }),
            headers: {
                [NotificationCenterHeaderName.X_EVENT]: JSON.stringify(eventLogTrackerData),
            },
        })

        const doc: JapiDocument = await response.json()

        if (! isResourceDocument<PersonResource>(doc) || ! doc.data) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const person = transformToPerson(doc.data)

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: person,
        }
    } catch (error) {
        console.error('[patchPersonApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
